import { createElement } from 'react';
import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { ProjetosPage } from '@/features/projetos/ProjetosPage';
import { ProjetoDetalhePage } from '@/features/projetos/ProjetoDetalhePage';
import { MinhasTarefasPage } from '@/features/projetos/MinhasTarefasPage';
import { CAMINHO_LISTA, CAMINHO_DETALHE } from '@/features/projetos/navegacao';

export const CAMINHO_MINHAS_TAREFAS = '/minhas-atividades';

export function criarRotasDeProjetos<TRotaPai extends AnyRoute>(rotaPai: TRotaPai) {
  const lista = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_LISTA,
    component: ProjetosPage,
  });

  const detalhe = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_DETALHE,
    component: () => {
      const { projetoId } = detalhe.useParams() as { projetoId: string };
      return createElement(ProjetoDetalhePage, { projetoId });
    },
  });

  const minhasAtividades = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_MINHAS_TAREFAS,
    component: MinhasTarefasPage,
  });

  return { lista, detalhe, minhasAtividades };
}

export { CAMINHO_LISTA, CAMINHO_DETALHE };
